import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthContext, AuthProvider } from "./context/AuthContext";
import Login from "./components/Login";
import Signup from "./components/Signup";
import Dashboard from "./components/Dashboard";
import Home from "./components/Home";
import Error from "./components/Error";
import { AnimatePresence } from "framer-motion";
import ForgotPassword from "./components/ForgotPassword";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import PetParentDashboard from "./components/Dashboards/PetParent/PetParentDashboard";
import MyPets from "./components/Dashboards/PetParent/MyPets";

import CreateService from "./components/Dashboards/Admin/CreateService";

import MyAppointment from "./components/Dashboards/PetParent/MyAppointment";
import AIDiagnostics from "./components/AdditionalPage/AIDiagnostics";
import VideoConsultations from "./components/AdditionalPage/VideoConsultations";
import EmergencyCare from "./components/AdditionalPage/EmergencyCare";
import LivestockManagement from "./components/AdditionalPage/LivestockManagement";
import HelpCenter from "./components/AdditionalPage/HelpCenter";
import AllPets from "./components/Dashboards/Admin/AllPets";
import AppointmentManager from "./components/Dashboards/Admin/AllAppointment";
import AdminDashboard from "./components/Dashboards/Admin/AdminDashboard";
import AddDoctorPage from "./components/Dashboards/Admin/AddDoctorPage";
import AllAppointmentForDoctor from "./components/Dashboards/Doctor/AllAppointmentForDoctor";
import AllUser from "./components/Dashboards/Admin/AllClient";
import SelfCheckUp from "./components/Dashboards/PetParent/SelfCheckUp";
import PaymentComponent from "./components/Payment/PaymentComponent";
import DoctorDashboard from "./components/Dashboards/Doctor/DoctorDashboard";

import ClientProfile from "./components/Dashboards/PetParent/ClientProfile";
import DoctorProfile from "./components/Dashboards/Doctor/DoctorProfilePage";
import Room from "./components/Rooms/Room";
import Meeting from "./components/Metings/Meeting";
import DoctorCheckUpForm from "./components/Dashboards/Doctor/DoctorCheckUpForm";
import Allcheckup from "./components/Dashboards/Doctor/Allcheckup";
import AppointmentForm from "./components/Dashboards/PetParent/AppointmentForm/AppointmentForm";

const App = () => {
  const { loginUser, logout } = useContext(AuthContext); // This now works because AuthProvider wraps it

  return (
    <Router className=""
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}>
      <AnimatePresence>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Meeting />} />
          <Route path="/room/:roomId" element={<Room />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/video-consultations" element={<VideoConsultations />} />
          <Route path="/ai-diagnostics" element={<AIDiagnostics />} />
          <Route path="/emergency-care" element={<EmergencyCare />} />
          <Route
            path="/livestock-management"
            element={<LivestockManagement />}
          />
          <Route path="/help-center" element={<HelpCenter />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/pay" element={<PaymentComponent />} />

          <Route element={<Dashboard />}>
            {loginUser?.role === "client" && (
              <>
                <Route path="/dashboard" element={<PetParentDashboard />} />
                <Route path="/dashboard/my-pets" element={<MyPets />} />
                <Route
                  path="/dashboard/create-appointment"
                  element={<AppointmentForm />}
                />
                <Route
                  path="/dashboard/self-checkup"
                  element={<SelfCheckUp />}
                />
                <Route
                  path="/dashboard/my-appointment"
                  element={<MyAppointment />}
                />
                <Route path="/dashboard/profile" element={<ClientProfile />} />
              </>
            )}
            {loginUser?.role === "admin" && (
              <>
                <Route path="/dashboard" element={<AdminDashboard />} />
                <Route path="/dashboard/all-pets" element={<AllPets />} />
                <Route path="/dashboard/all-user" element={<AllUser />} />
                <Route
                  path="/dashboard/all-appointment"
                  element={<AppointmentManager />}
                />
                <Route
                  path="/dashboard/create-service"
                  element={<CreateService />}
                />
                <Route
                  path="/dashboard/add-doctor"
                  element={<AddDoctorPage />}
                />
              </>
            )}

            {loginUser?.role === "doctor" && (
              <>
                <Route path="/dashboard" element={<DoctorDashboard />} />
               
                <Route
                  path="/dashboard/all-appointment"
                  element={<AllAppointmentForDoctor />}
                />
                <Route path="/dashboard/check-up" element={<Allcheckup />} />
                <Route
                  path="/dashboard/check-up/:appointmentId"
                  element={<DoctorCheckUpForm />}
                />
                <Route path="/dashboard/profile" element={<DoctorProfile />} />
              </>
            )}

            <Route path="*" element={<Error />} />
          </Route>
        </Routes>
      </AnimatePresence>
    </Router>
  );
};

const RootApp = () => (
  <AuthProvider>
    <App />
    <ToastContainer />
  </AuthProvider>
);

export default RootApp;
